// DO NOT EDIT -- generated from fs/services/warehauser/warehauser-bundler.proto

import { WarehauserBundlerTask } from './warehauser.proto';
import * as protobuf from '../../../google/protobuf';
import * as schema from '../../shared/schema';

export namespace BundleService {

  export const AdhocBundleEndpoint = "/grpc/warehauser.BundleService/AdhocBundle";
  /** AdhocBundle creates an isolated bundle that will not be synced, mostly for troubleshooting purposes. */
  export function AdhocBundle(sender: (req: AdhocBundleRequest, endpoint: string) => Promise<AdhocBundleResponse>, req: AdhocBundleRequest): { promise: () => Promise<AdhocBundleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AdhocBundleEndpoint),
      endpoint: AdhocBundleEndpoint
    };
  }

  export const ScheduleBundleEndpoint = "/grpc/warehauser.BundleService/ScheduleBundle";
  /**
   * ScheduleBundle publishes a bundler task to create a bundle to be synced later, e.g., to fix a corrupted bundle.
   * Make sure the task is valid for asynchronous processing. Caution: this could create duplicates in the downstream.
   */
  export function ScheduleBundle(sender: (req: WarehauserBundlerTask, endpoint: string) => Promise<{}>, req: WarehauserBundlerTask): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ScheduleBundleEndpoint),
      endpoint: ScheduleBundleEndpoint
    };
  }
}

export interface AdhocBundleRequest {
  orgId: string;
  /** if set, only events on or after the start will be included in the bundle. */
  eventTimeStart: protobuf.timestamp | null;
  /** if set, only events before the end will be included in the bundle. */
  eventTimeEnd: protobuf.timestamp | null;
  scanPagesByStart?: AdhocBundleRequest.ScanPages | null;
  pagesList?: AdhocBundleRequest.ListPages | null;
  /**
   * if omitted, a name will be automatically generated for this request.
   * do not include extension like .parquet.
   */
  bundleName: string;
  /** if omitted, the bundle will be created in the root adhoc directory. */
  subDirectory: string;
}

export namespace AdhocBundleRequest {
  export interface ScanPages {
    /**
     * the start to scan pages by starts (on or after the start will be included).
     * it may take up to 24 hours for pages to be consistent and able to be scanned.
     */
    start: protobuf.timestamp | null;
    /**
     * the end to scan pages by starts (before the end will be included).
     * it may take up to 24 hours for pages to be consistent and able to be scanned.
     */
    end: protobuf.timestamp | null;
  }

  export interface ListPages {
    args: schema.PageArgsProto[];
  }

  export enum pages {
    scanPagesByStart = 4,
    pagesList = 5
  }

  export function pages_oneof(m: AdhocBundleRequest): { opt: pages.pagesList, val: AdhocBundleRequest.ListPages } | { opt: pages.scanPagesByStart, val: AdhocBundleRequest.ScanPages } | null {
    if (m.scanPagesByStart != null) { return { opt: pages.scanPagesByStart, val: m.scanPagesByStart } }
    if (m.pagesList != null) { return { opt: pages.pagesList, val: m.pagesList } }
    return null;
  }
}

export interface AdhocBundleResponse {
  pages: protobuf.uint64;
  events: protobuf.uint64;
  bucket: string;
  object: string;
  link: string;
  syncTask: boolean;
}

/** BundlePages is the storage format of the page ids in a bundle. The ids are grouped to save space. */
export interface BundlePages {
  userIds: protobuf.int64[];
  sessionIds: protobuf.int64[];
  pageIds: protobuf.int64[];
}
